import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const walls = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 200,
      total: 0,
      page: 1,
    },
    selectedItems: [],
    loading: true,
    questions: [],
    participants: [],
  }),
  mutations: {
    setWalls(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedWalls(state, payload) {
      state.selectedItems = payload;
    },
    setWallPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getWalls");
    },
    setWallTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getWalls");
    },
  },
  actions: {
    async confirmQuestion(store, payload) {
      await axios
        .post("asktospeaker/changestatus", {
          status: 1,
          id: store.state.questions[payload.index].id,
        })
        .then((res) => {
          store.state.questions[payload.index].status = 1;
          payload.context.$message.success(res.data.alert.message);
        });
    },
    async rejectQuestion(store, payload) {
      await axios
        .post("asktospeaker/changestatus", {
          status: 10,
          id: store.state.questions[payload.index].id,
        })
        .then((res) => {
          store.state.questions[payload.index].status = 10;
          payload.context.$message.success(res.data.alert.message);
        });
    },
    async getWalls(store) {
      store.state.loading = true;
      await axios
        .post("asktospeaker/loadwalls", {
          ...store.state.filter,
          skip: (store.state.filter.page - 1) * store.state.filter.take,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setWalls", res.data.data);
        });
    },
    async getWallQuestions(store, payload) {
      await axios
        .post("asktospeaker/load", {
          skip: 0,
          take: 1000,
          searchTerm: null,
          askToSpeakerID: payload,
          participantNO: null,
          sort: 1,
        })
        .then((res) => {
          store.state.questions = res.data.data.items;
          store.state.participants = res.data.data.participants;
        });
    },
    async toggleWall(store, payload) {
      var res = await axios.post("asktospeaker/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteWall(store, payload) {
      await axios
        .post("asktospeaker/deletewall", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setWallPage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
    async deleteQuestion(store, payload) {
      await axios
        .post("asktospeaker/delete", {
          id: store.state.questions[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.questions.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
          }
        });
    },
  },
  getters: {},
};
export default walls;



// WEBPACK FOOTER //
// ./src/store/walls.js